import React from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Step4Agreement.module.css';

const AGREEMENTS = [
  {
    name: 'factoryAgreementPartnership',
    label: 'ChinaDolphins Factory Partnership Agreement',
    url: '/factory-partnership',
  },
  {
    name: 'factoryAgreementPrivacy',
    label: 'Privacy & Data Policy (including Information Masking & Anti-Circumvention)',
    url: '/privacy-policy',
  },
  {
    name: 'factoryAgreementEthics',
    label: 'ChinaDolphins Global Code of Ethics & Social Responsibility',
    url: '/code-of-ethics',
  },
  {
    name: 'factoryAgreementAml',
    label: 'ChinaDolphins Global Trade & AML Compliance Policy',
    url: '/trade-aml-compliance',
  },
];

const Step4Agreement = ({ nextStep, prevStep, initialValues, className, rootClassName }) => {
  const classes = classNames(rootClassName || css.root, className);

  const validate = values => {
    const errors = {};
    AGREEMENTS.forEach(a => {
      if (!values[a.name]) errors[a.name] = 'You must accept this agreement to continue';
    });
    return errors;
  };

  const onSubmit = values => {
    nextStep(values);
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({ handleSubmit, submitFailed, errors }) => (
        <form onSubmit={handleSubmit} className={classNames(classes, css.form)}>
          <div className={css.header}>
            <span className={css.step}>Step 4 of 5</span>
            <h2 className={css.title}>Partnership Agreement &amp; Compliance</h2>
            <p className={css.description}>
              Please read and accept all mandatory agreements below to continue factory registration.
            </p>
          </div>

          <hr className={css.divider} />

          {submitFailed && Object.keys(errors).length > 0 && (
            <div className={css.submitError}>
              ⚠ Please accept all required agreements before continuing.
            </div>
          )}

          <div className={css.card}>
            {AGREEMENTS.map(agreement => (
              <Field key={agreement.name} name={agreement.name} type="checkbox">
                {({ input, meta }) => (
                  <div className={classNames(css.row, { [css.rowError]: meta.touched && meta.error })}>
                    <div className={css.left}>
                      <input {...input} type="checkbox" />
                      <div>
                        <span>
                          {agreement.label}
                          <span className={css.required}> *</span>
                        </span>
                        {meta.touched && meta.error && (
                          <div className={css.fieldError}>{meta.error}</div>
                        )}
                      </div>
                    </div>
                    <button
                      type="button"
                      className={css.view}
                      onClick={() => window.open(agreement.url, '_blank')}
                    >
                      View
                    </button>
                  </div>
                )}
              </Field>
            ))}
          </div>

          <div className={css.infoBox}>
            <p>
              ✓ By checking all agreements, you confirm that you are an authorised corporate representative
              and agree to operate under ChinaDolphins manufacturing partner standards.
            </p>
          </div>

          <div className={css.buttonContainer}>
            <button type="button" onClick={prevStep} className={css.previous}>
              ← Previous
            </button>
            <button type="submit" className={css.button}>
              Next : Review →
            </button>
          </div>
        </form>
      )}
    />
  );
};

Step4Agreement.defaultProps = {
  className: null,
  rootClassName: null,
  initialValues: {},
};

Step4Agreement.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default Step4Agreement;
